import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Template Statistics</Typography>
      <p>A basic chart that shows number of passes issued each day.</p>
      <p>Test and Live passes are shown separately.</p>
    </div>
  )
}

export default HelpText